import React, { useEffect, useState } from "react";
import {
  Button,
  Progress,
  Row,
  Col,
  Form,
  Input,
  Modal,
  Divider,
  message,
} from "antd";

import IICONimage from "../../assets/images/i-icon-mainhj.svg";
import UserImage from "../../assets/images/profile-image.png";
import Main from "../../components/layout/Main";
import CheckImage from "../../assets/images/check-orange-image.svg";
import { useWallet, loadRecentRecipients } from "../../context/WalletContext";
import { isValidUrl, toCapitalize } from "../../helper/functions";
import { useNavigate } from "react-router-dom";

const SendTokens = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const userProfileData = JSON.parse(localStorage.getItem("userProfile"));
  const walletSummaryData = JSON.parse(localStorage.getItem("walletSummary"));
  const [recentRecipients, setRecentRecipients] = useState([]);
  const [sentTokenModal, setSentTokenModal] = useState(false);
  const { sendToken, loadRecentRecipients } = useWallet();
  const navigate = useNavigate();

  const [isConfirmPaymentModalOpen, setIsConfirmPaymentModalOpen] =
    useState(false);

  const handleOk = () => {
    setIsConfirmPaymentModalOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmPaymentModalOpen(false);
  };

  // ---------- handlers -----------
  const handleFinish = async (values) => {
    const data = {
      recipient: values.name,
      amount:
        Number(values.amount) +
        (values.amount * walletSummaryData.limits.feeIntrest) / 100,
      notes: `${values.amount} Token transfer`,
    };
    const response = await sendToken(data);
    if (response.success) {
      setIsModalVisible(false);
      setSentTokenModal(true);
      form.resetFields();
    }
  };

  const fetchRecentRecipients = async () => {
    const response = await loadRecentRecipients();
    if (response.success) {
      setRecentRecipients(response.data.recipients);
    }
  };

  const handleSendToken = async () => {
    try {
      await form.validateFields(["name", "amount"]);
      setIsModalVisible(true);
    } catch (error) {
      return;
    }
  };
  // ---------- use effects -------------
  useEffect(() => {
    fetchRecentRecipients();
  }, []);

  return (
    <Main>
      <div className="wallet-page">
        <div className="orange-header">Send Tokens</div>

        <Form
          form={form}
          layout="vertical"
          className="tournament-form"
          onFinish={handleFinish}
        >
          <Row gutter={24}>
            <Col span={24} md={10}>
              <Form.Item
                label="Recipient Username"
                name="name"
                rules={[{ required: true, message: "Please enter user name" }]}
              >
                <Input placeholder="Enter recipient user name" />
              </Form.Item>
              <Form.Item
                label="Amount"
                name="amount"
                rules={[{ required: true, message: "Please enter amount" }]}
              >
                <Input placeholder="Please enter amount" type="number" />
              </Form.Item>
              <div className="available-tokenn">
                Available:{" "}
                <span>{walletSummaryData?.wallet.total_balance} TKN</span>
              </div>
              <div className="daily-trabsfer-limiit">
                <img src={IICONimage} />
                <div className="daily-trabsfer-limiit-text">
                  <h5>Daily Transfer Limit</h5>
                  <p>You can send up to 325 TKN more today</p>
                </div>
              </div>
              <Form.Item label="Recent Recipients">
                <div className="iser-image-90-flexx">
                  {recentRecipients?.map((recipient, index) => (
                    <div className="iser-image-90" key={index}>
                      <img
                        src={
                          isValidUrl(recipient?.image)
                            ? recipient.image
                            : UserImage
                        }
                      />
                      <h5>{toCapitalize(recipient?.username)}</h5>
                    </div>
                  ))}
                </div>
              </Form.Item>
              <div className="send-token-image mt-5">
                <Button
                  className="token-send-button Fill-button"
                  onClick={() => handleSendToken()}
                >
                  Send Tokens
                </Button>

                {/* Confirmation Modal */}
                <Modal
                  open={isModalVisible}
                  className="order-success-modal"
                  onCancel={() => setIsModalVisible(false)}
                  footer={null}
                  closable
                  width={452}
                  centered
                >
                  <h3 className="modal-title">Confirmation?</h3>

                  <div className="modal-list-send">
                    <h4>User</h4>
                    <h3>{userProfileData?.name}</h3>
                  </div>

                  <div className="modal-list-send">
                    <h4>Amount</h4>
                    <h3>{form.getFieldValue("amount")}</h3>
                  </div>
                  <Divider className="new-deviderhh" />
                  <div className="modal-list-send">
                    <h4>Network Fee</h4>
                    <h3>
                      {(form.getFieldValue("amount") *
                        walletSummaryData?.limits.feeIntrest) /
                        100}
                      TKN
                    </h3>
                  </div>

                  <Divider className="new-deviderhh" />

                  <div className="modal-list-send">
                    <h5>Total to Send</h5>
                    <h5>
                      {Number(form.getFieldValue("amount")) +
                        Number(
                          (form.getFieldValue("amount") *
                            walletSummaryData?.limits.feeIntrest) /
                            100,
                        )}
                      TKN
                    </h5>
                  </div>

                  <div className="modal-footer12">
                    {/* <Button className="Fill-button" onClick={showModal}> */}
                    <Button
                      className="Fill-button"
                      onClick={() => form.submit()}
                    >
                      Confirm send
                    </Button>

                    {/* -------------- confirm purchased modal ---------------  */}
                    <Modal
                      open={sentTokenModal}
                      onOk={handleOk}
                      onCancel={handleCancel}
                      footer={null}
                      width={452}
                      centered
                      className="ConfirmPaymentColor"
                    >
                      <div className="confirm-payement-modaal">
                        <img src={CheckImage} />
                        <h2>Purchased Successful</h2>
                        <p>You’ve successfully purchased 500 Tokens</p>
                        <div className="secess-modal-footer">
                          <Button
                            className="Fill-button-small"
                            onClick={handleOk}
                          >
                            Return to Wallet
                          </Button>
                          <Button className="light-button" onClick={handleOk}>
                            Explore Store
                          </Button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </Modal>
              </div>
            </Col>
            <Col span={24} md={8}>
              <div className="wallet-limits-card-inner">
                <div className="header-wallet-proo">
                  <p>Sending Limit</p>
                  <h5>25%</h5>
                </div>
                <Progress
                  percent={25}
                  showInfo={false}
                  className="wallet-progress"
                />
                <p className="wallet-progress-label">
                  150 TKN remaining for gifts
                </p>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      {/* ------------ send token successfully modal -------------- */}
      <Modal
        open={sentTokenModal}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={452}
        centered
        className="ConfirmPaymentColor"
      >
        <div className="confirm-payement-modaal">
          <img src={CheckImage} />
          <h2>Sent Token Successful</h2>
          <p>
            {" "}
            You’ve successfully sent {form.getFieldValue("amount")} Tokens.
          </p>
          <div className="secess-modal-footer">
            <Button
              className="Fill-button-small"
              onClick={() => {
                setSentTokenModal(false);
                navigate("/wallet");
              }}
            >
              Return to Wallet
            </Button>
            <Button
              className="light-button"
              onClick={() => {
                setSentTokenModal(false);
                navigate("/stores");
              }}
            >
              Explore Store
            </Button>
          </div>
        </div>
      </Modal>
    </Main>
  );
};

export default SendTokens;
